import { DeepPartial } from "@towersystems/roam-common/lib/shared-types";
import { ReceiptType } from "../../types";
import { PosApiResponse } from "../pos-api-response";

export class ReceiptResponse extends PosApiResponse {
  constructor(input?: DeepPartial<ReceiptResponse>) {
    super(input);
    // Re-apply after super(): subclass field declarations reset declared
    // properties to undefined once super() returns, wiping the values
    // BaseResponse copied. Re-assigning here restores the API payload.
    if (input) {
      Object.assign(this, input);
    }
    if (!this.ReceiptText) {
      this.ReceiptText = [];
    }
  }

  // The receipt type.
  public Type: ReceiptType;

  // Receipt text to be printed.
  public ReceiptText: string[];

  // Receipt response is a pre-print
  public IsPrePrint: boolean;
}
